import { SupportedLocales } from "../localization";

export type CPAPILocale =
    | "de-DE"
    | "en-US"
    | "es"
    | "fr-FR"
    | "it-IT"
    | "ja-JP"
    | "ko-KR"
    | "nl-NL"
    | "pl-PL"
    | "pt-BR"
    | "ru-RU"
    | "zh-CN"
    | "xx"
    | "zz";

const isProductionEnvironment = process.env["NODE_ENV"] === "production";
const commonLocales: Record<SupportedLocales, CPAPILocale> = {
    br: "pt-BR",
    de: "de-DE",
    en: "en-US",
    es: "es",
    fr: "fr-FR",
    it: "it-IT",
    ja: "ja-JP",
    ko: "ko-KR",
    nl: "nl-NL",
    pl: "pl-PL",
    ru: "ru-RU",
    zh: "zh-CN"
};
const nonProdLocales: Record<SupportedLocales, CPAPILocale> = {
    xx: "en-US",
    zz: "en-US"
};

export const WAC_TO_CPAPI_LOCALE_MAP: Record<SupportedLocales, CPAPILocale> =
    isProductionEnvironment
        ? commonLocales
        : { ...commonLocales, ...nonProdLocales };

export const TEMPLATE_CATEGORY_OBJ = {
    id: "7ckISKU5UGRFKMEQyFf123",
    name: "Recommended for you",
    urlSlug: "recommended",
    shortDescriptionOneLiner:
        "Check out our personalized list of templates relevant to you and your team.",
    pageTitle: "Recommended templates for you",
    description: null,
    experiment: false
};
export const RECO_TEMPLATE_LOCAL_STORAGE_NAME = "template_reco";
